import { render, staticRenderFns } from "./StepsThird.vue?vue&type=template&id=1817b059&scoped=true"
import script from "./StepsThird.vue?vue&type=script&lang=js"
export * from "./StepsThird.vue?vue&type=script&lang=js"
import style0 from "./StepsThird.vue?vue&type=style&index=0&id=1817b059&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1817b059",
  null
  
)

export default component.exports